"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Radio = _interopRequireDefault(require("./Radio.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Radio = function Radio(_ref) {
  var iconChecked = _ref.iconChecked,
    iconUnchecked = _ref.iconUnchecked,
    textAsIcon = _ref.textAsIcon,
    disabled = _ref.disabled,
    name = _ref.name,
    checked = _ref.checked,
    className = _ref.className,
    onChange = _ref.onChange,
    value = _ref.value,
    id = _ref.id,
    ariaLabel = _ref.ariaLabel,
    label = _ref.label,
    naked = _ref.naked,
    withNativeInput = _ref.withNativeInput;
  var additionalProps = {};
  if (!withNativeInput) {
    additionalProps.onMouseDown = function (ev) {
      ev.stopPropagation();
      onChange(value);
    };
  }
  return /*#__PURE__*/_react["default"].createElement(_Radio["default"], _extends({
    id: id ? "radio-wrapper-".concat(id) : null,
    naked: naked,
    className: "radio-wrapper",
    checked: checked,
    disabled: disabled,
    "aria-label": ariaLabel || name
  }, additionalProps), withNativeInput && /*#__PURE__*/_react["default"].createElement("input", {
    type: "radio",
    id: id,
    value: value,
    name: name,
    disabled: disabled,
    checked: checked,
    className: className,
    onChange: onChange
  }), textAsIcon ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-as-icon"
  }, textAsIcon) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: checked ? iconChecked : iconUnchecked
  }), label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "radio-label"
  }, label));
};
Radio.propTypes = {
  /**
   * Wether the component should use the native checkbox(in certain scenarious onMouseDown needs to be fired)
   * hence this aproach
   */
  withNativeInput: _propTypes["default"].bool,
  /**
   * If `true`, the component will only display the font icon provided
   */
  naked: _propTypes["default"].bool,
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes["default"].bool,
  /**
   * The css classes for the checkbox element
   */
  className: _propTypes["default"].string,
  /**
   * The icon string to be used when checked
   */
  iconChecked: _propTypes["default"].string,
  /**
   * The icon string to be used when un-checked
   */
  iconUnchecked: _propTypes["default"].string,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * The id of the `checkbox` element.
   */
  id: _propTypes["default"].string,
  /*
   * The name attribute of the checkbox element
   */
  name: _propTypes["default"].string,
  /*
   * The aria label for the radio element
   */
  ariaLabel: _propTypes["default"].string,
  /*
   * The label for the radio element
   */
  label: _propTypes["default"].string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes["default"].func,
  /**
   * The value of the component.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /** If passed, it will replace the Icon component with the custom text */
  textAsIcon: _propTypes["default"].string
};
Radio.defaultProps = {
  withNativeInput: true,
  iconChecked: 'ion-checkmark',
  iconUnchecked: 'ion-checkmark',
  checked: false,
  className: '',
  disabled: false,
  id: '',
  name: '',
  onChange: null,
  value: '',
  ariaLabel: '',
  naked: false,
  label: '',
  textAsIcon: ''
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Radio);